import {
    FLAT_RATE_PLANS,
    PLAN_BASE_FEATURES,
    PREMIUM_FEATURES,
} from "@common/flatRateBilling";
import { PLAN_CAPABILITY_UPGRADE_MESSAGES } from "@common/planCapabilities";
import { TASK_TYPE_DEFINITIONS } from "@common/constants/taskTypeDefinitions";
import { TaskType } from "@common/types/taskType";

export const getRequiredFeatureForTaskType = (
    type: TaskType,
): PREMIUM_FEATURES | null => TASK_TYPE_DEFINITIONS[type].requiredFeature;

export function doesPlanHaveTaskTypeAccess(
    type: TaskType,
    plan: FLAT_RATE_PLANS | null | undefined,
): boolean {
    const requiredFeature = getRequiredFeatureForTaskType(type);
    if (!requiredFeature) {
        return true;
    }
    return PLAN_BASE_FEATURES[plan ?? FLAT_RATE_PLANS.FREE].includes(
        requiredFeature,
    );
}

export function getBlockedTaskTypesForPlan(
    types: readonly TaskType[],
    plan: FLAT_RATE_PLANS | null | undefined,
): TaskType[] {
    return types.filter((type) => !doesPlanHaveTaskTypeAccess(type, plan));
}

/**
 * Returns the most prominent upgrade message for the given blocked task types,
 * or null if no task types are blocked.
 */
export function getUpgradeMessageForBlockedTaskTypes(
    blockedTaskTypes: readonly TaskType[],
): string | null {
    for (const type of blockedTaskTypes) {
        const feature = getRequiredFeatureForTaskType(type);
        if (feature) {
            return PLAN_CAPABILITY_UPGRADE_MESSAGES[feature];
        }
    }
    return null;
}
